import { useSyncExternalStore } from 'react'
import type { AuthErrorState } from './auth-error'

// Tiny observable store for the current session-level auth-error state (ADR-0012).
// The API client sets it from the typed classification; components subscribe via
// `useAuthErrorState`. Not a session/token store — only UI state.

let state: AuthErrorState | null = null
const listeners = new Set<() => void>()

export function setAuthErrorState(next: AuthErrorState | null): void {
	state = next
	for (const listener of listeners) listener()
}

export function getAuthErrorState(): AuthErrorState | null {
	return state
}

export function clearAuthErrorState(): void {
	setAuthErrorState(null)
}

export function useAuthErrorState(): AuthErrorState | null {
	return useSyncExternalStore(
		(cb) => {
			listeners.add(cb)
			return () => {
				listeners.delete(cb)
			}
		},
		getAuthErrorState,
		getAuthErrorState,
	)
}
